import { render } from "./OfficeFornecedoresTab.vue?vue&type=template&id=6434600a&scoped=true&ts=true"
import script from "./OfficeFornecedoresTab.vue?vue&type=script&lang=ts"
export * from "./OfficeFornecedoresTab.vue?vue&type=script&lang=ts"

import "./OfficeFornecedoresTab.vue?vue&type=style&index=0&id=6434600a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6434600a"]])

export default __exports__